import { PropsWithChildren } from 'react'
import { TextLink as DSTextLink } from '@boltenergy-be/design-system'
import { TextLinkProps } from './types'
import NextLink from 'next/link'

const Link = ({
  as,
  children,
  href,
  destructive,
  size,
  representation,
  variant,
  external,
  trailingIcon,
  leadingIcon,
  isFullwidth,
  isFullwidthMobile,
  target,
  loading,
  disabled,
  ...nativeProps
}: PropsWithChildren<TextLinkProps>) => {
  const DSTextLinkProps = {
    destructive,
    size,
    representation,
    variant,
    external,
    trailingIcon,
    leadingIcon,
    isFullwidth,
    isFullwidthMobile,
    loading,
    disabled
  }

  return (
    <DSTextLink
      cloneElement={
        as === 'a' || external ? (
          <a href={href} target={target || (external ? '_blank' : undefined)} rel="noreferrer noopener" {...nativeProps}>
            {children}
          </a>
        ) : (
          <NextLink href={href!} target={target} {...nativeProps}>
            {children}
          </NextLink>
        )
      }
      {...DSTextLinkProps}
    />
  )
}

export default Link
